import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MdLocationPin } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import Style from '../Styles/Common.module.css';
import Button from '../Styles/Button.module.css';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";
const GalleryComponent = ()=>{
    const smoothScroll = () => {
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      };

    return(
        <div className={Style.committeesec +" "+Style.clear}>
        <Container>
        <Row>
            <Col>
                    <div className={Style.center}>
                        <h2 className={Style.abouttitle}>Committee members</h2>
                    </div>
                    </Col>
                    </Row>
                    <Row>
                        <Row>
                            <Col>
                                <ul className={Style.memberLst}>
                                    {/* <li>Mr. Alok Bansidhar Shriram</li>
                                    <li>Mr. Sameer Mutreja</li> 
                                    <li>Mr. Sandeep Suri</li>
                                    <li>Mr. Kirit Javali</li>
                                    <li>Dr. Jitendra Nath Mishra</li>
                                    <li>Mr. Ambarish Raghuvanshi</li>
                                    <li>Mr. Vilas Pawar</li>*/}
                                    <li>Mr. Dipin Kapur</li>
                                    <li>Mr. Vikramjit Singh</li>
                                    <li>Mr. Vikramaditya Jaitly</li>
                                    <li>Mr. Goumtesh Singh</li>
                                    <li>Mr. Peeyush Sharma</li>
                                    <li>Ms. Vidushi Gulati</li>
                                    <li>Mr. Pratheek Shankar</li>

                                </ul>
                            </Col>
                        </Row>
            </Row>
        </Container>
    </div>
    )
}

export default GalleryComponent;